var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.781,
    height: 40.781,
    viewBox: "0 0 40.781 40.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatbubbles",
    "data-name": "Icon ionic-ios-chatbubbles",
    transform: "translate(-4.625 -2.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M39.406,30.426a2.4,2.4,0,0,1,.327-1.211,3.342,3.342,0,0,1,.208-.308,16.079,16.079,0,0,0,2.739-8.961C42.711,10.8,34.99,3.375,25.444,3.375a17.118,17.118,0,0,0-16.9,13.188,15.947,15.947,0,0,0-.367,3.394,16.833,16.833,0,0,0,16.969,16.78,20.437,20.437,0,0,0,4.684-.764c1.121-.308,2.233-.714,2.521-.824a2.623,2.623,0,0,1,.923-.169,2.58,2.58,0,0,1,1,.2L39.9,37.174a1.342,1.342,0,0,0,.387.1.79.79,0,0,0,.794-.794,1.275,1.275,0,0,0-.05-.268Z",
    transform: "translate(1.975 0)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M30.218,33.642c-.357.1-.814.208-1.31.318a18.315,18.315,0,0,1-3.374.447A16.833,16.833,0,0,1,8.565,17.626,18.761,18.761,0,0,1,8.714,15.5c.06-.427.129-.853.228-1.27.1-.447.218-.893.347-1.33l-.794.7a14.768,14.768,0,0,0-5.12,11.1,14.6,14.6,0,0,0,2.461,8.137c.228.347.357.615.318.794s-1.181,6.152-1.181,6.152a.8.8,0,0,0,.268.764.808.808,0,0,0,.506.179.712.712,0,0,0,.288-.06L11.6,38.485a1.55,1.55,0,0,1,.566-.109,1.566,1.566,0,0,1,.625.129A16.7,16.7,0,0,0,18.816,39.7a15.585,15.585,0,0,0,11.918-5.468s.318-.437.685-.953C31.051,33.4,30.635,33.533,30.218,33.642Z",
    transform: "translate(2 1.919)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.c855fdfd46a6471026eb6dbdc5398acd.svg";
export { ForwardRef as ReactComponent };